import { useApi } from "../hooks/useApi";
import { api } from "../lib/api";
import { FeedSkeleton } from "../components/Skeleton";
import { PostCard } from "../components/PostCard";
import { Stories } from "../components/Stories";
import { Verified } from "../components/Verified";
import { AdTile } from "../components/AdTile";

export function HomePage() {
  const feed = useApi(() => api.feed(), []);
  const ads = useApi(() => api.ads("feed"), []);
  const stories = useApi(api.stories, []);
  const explore = useApi(api.explore, []);
  return (
    <div className="home-grid">
      <section className="feed-column">
        {stories.data && <Stories stories={stories.data} />}
        {feed.loading && <FeedSkeleton />}
        {feed.error && <div className="state">Worker unreachable. {feed.error}</div>}
        {feed.data?.map((post, index) => {
          const ad = ads.data?.find((item) => item.position === index + 1);
          return <div className="feed-unit" key={post.id}><PostCard post={post} />{ad && <AdTile ad={ad} />}</div>;
        })}
        {feed.data?.length === 0 && <div className="state">The feed is empty.</div>}
      </section>
      <aside className="right-rail">
        <h2>Suggested</h2>
        {explore.data?.featuredAccounts.slice(0, 5).map((user) => (
          <a className="suggestion" href={`/@${user.username}`} key={user.id}><img src={user.avatarUrl} alt="" /><span><strong>{user.displayName}<Verified show={user.citizenVerified || user.verified} /></strong><em>@{user.username}</em></span></a>
        ))}
        <h2>Trending in Floptropica</h2>
        <div className="trend-list">{explore.data?.trending.slice(0, 5).map(({ post, score }) => <a href={`/p/${post.id}`} key={post.id}><strong>{post.hashtags[0] ? `#${post.hashtags[0]}` : post.location || "feed"}</strong><span>{score} heat</span></a>)}</div>
      </aside>
    </div>
  );
}
